import * as Icons from "lucide-react";
import { CATEGORIES, BRAND } from "@/lib/brand";
import { ArrowUpRight } from "lucide-react";

export const Categories = () => {
  return (
    <section
      id="categorias"
      data-testid="categories-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-5 reveal">
              <span className="divider-gold" />
              <span className="tracking-eyebrow text-gold">Categorias de Produtos</span>
            </div>
            <h2
              className="font-display text-4xl lg:text-5xl font-bold text-navy leading-[1.05] tracking-[-0.025em] reveal"
              data-testid="categories-title"
            >
              Da peça mais simples
              <br />
              à solução mais complexa.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-4">
            <p className="text-lg text-slate-600 leading-relaxed reveal">
              Atuamos em 12 categorias essenciais para operação industrial —
              rolamentos, motores, redutores, automação e muito mais.
              <br />
              <span className="text-navy font-semibold">
                Não encontrou o que precisa? Fale conosco: buscamos por você.
              </span>
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {CATEGORIES.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Package;
            return (
              <a
                key={c.name}
                href={BRAND.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`category-card-${i}`}
                className="reveal group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 card-lift"
                style={{ transitionDelay: `${i * 40}ms` }}
                aria-label={`Solicitar cotação de ${c.name}`}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-12 h-12 rounded-xl bg-mist border border-slate-200 flex items-center justify-center group-hover:bg-navy group-hover:border-navy transition-colors">
                    <Icon className="w-5 h-5 text-navy group-hover:text-white transition-colors" />
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-slate-300 group-hover:text-gold transition-colors" />
                </div>
                <div className="font-display text-lg font-semibold text-navy leading-snug">
                  {c.name}
                </div>
                <div className="mt-1 text-xs text-slate-400">
                  Cotação sob demanda
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
